import { render, staticRenderFns } from "./Veicoli.vue?vue&type=template&id=dc4cba3a&"
import script from "./Veicoli.vue?vue&type=script&lang=ts&"
export * from "./Veicoli.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports